import {POPerson} from '@obj-models/POPerson';

export class POConflict {
  first: POPerson;
  second: POPerson;
  static virtualType = 'Conflict';
}
